/* eslint-disable max-len */
import React from 'react';

const PauseMonitor: React.FC<object> = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="8" fill="#E7E7E7"/>
            <rect width="2.21226" height="8.84902" rx="1.10613" transform="matrix(1 0 0 -1 5 12.6133)" fill="#A7B4B4"/>
            <rect width="2.21226" height="8.84902" rx="1.10613" transform="matrix(1 0 0 -1 8.98242 12.6133)" fill="#A7B4B4"/>
        </svg>
    );
};

export default PauseMonitor;